// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AlgarveBoatRouteImport } from './routes/algarve-boat'
import { Route as AlvorLagoonCruiseRouteImport } from './routes/alvor-lagoon-cruise'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BenagilCaveTourRouteImport } from './routes/benagil-cave-tour'
import { Route as BirthdayCruiseVilamouraRouteImport } from './routes/birthday-cruise-vilamoura'
import { Route as BoatHireAlgarveRouteImport } from './routes/boat-hire-algarve'
import { Route as BoatHireVilamouraRouteImport } from './routes/boat-hire-vilamoura'
import { Route as BoatTripsAlbufeiraRouteImport } from './routes/boat-trips-albufeira'
import { Route as BoatTripsFaroRouteImport } from './routes/boat-trips-faro'
import { Route as BoatTripsQuarteiraRouteImport } from './routes/boat-trips-quarteira'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as DestinationsRouteImport } from './routes/destinations'
import { Route as DolphinWatchingVilamouraRouteImport } from './routes/dolphin-watching-vilamoura'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as PrivateBoatRentalVilamouraRouteImport } from './routes/private-boat-rental-vilamoura'
import { Route as PrivateYachtCharterVilamouraRouteImport } from './routes/private-yacht-charter-vilamoura'
import { Route as ProposalCruiseVilamouraRouteImport } from './routes/proposal-cruise-vilamoura'
import { Route as PtRouteImport } from './routes/pt'
import { Route as RiaFormosaTaviraCruiseRouteImport } from './routes/ria-formosa-tavira-cruise'
import { Route as SunsetCruiseVilamouraRouteImport } from './routes/sunset-cruise-vilamoura'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TheMorningstarRouteImport } from './routes/the-morningstar'
import { Route as TrustCentreRouteImport } from './routes/trust-centre'
import { Route as VilamouraBoatTripsRouteImport } from './routes/vilamoura-boat-trips'
import { Route as VilamouraHenPartyCruiseRouteImport } from './routes/vilamoura-hen-party-cruise'
import { Route as PtIndexRouteImport } from './routes/pt.index'
import { Route as PtAluguerDeBarcoAlgarveRouteImport } from './routes/pt.aluguer-de-barco-algarve'
import { Route as PtAluguerDeBarcoVilamouraRouteImport } from './routes/pt.aluguer-de-barco-vilamoura'
import { Route as PtBarcoAlgarveRouteImport } from './routes/pt.barco-algarve'
import { Route as PtCentroDeConfiancaRouteImport } from './routes/pt.centro-de-confianca'
import { Route as PtCharterIatePrivadoVilamouraRouteImport } from './routes/pt.charter-iate-privado-vilamoura'
import { Route as PtCruzeiroAniversarioVilamouraRouteImport } from './routes/pt.cruzeiro-aniversario-vilamoura'
import { Route as PtCruzeiroDespedidaSolteiraVilamouraRouteImport } from './routes/pt.cruzeiro-despedida-solteira-vilamoura'
import { Route as PtCruzeiroLagunaAlvorRouteImport } from './routes/pt.cruzeiro-laguna-alvor'
import { Route as PtCruzeiroPedidoCasamentoVilamouraRouteImport } from './routes/pt.cruzeiro-pedido-casamento-vilamoura'
import { Route as PtCruzeiroPorDoSolVilamouraRouteImport } from './routes/pt.cruzeiro-por-do-sol-vilamoura'
import { Route as PtCruzeiroRiaFormosaTaviraRouteImport } from './routes/pt.cruzeiro-ria-formosa-tavira'
import { Route as PtDestinosRouteImport } from './routes/pt.destinos'
import { Route as PtFaqRouteImport } from './routes/pt.faq'
import { Route as PtGrutaDeBenagilRouteImport } from './routes/pt.gruta-de-benagil'
import { Route as PtOMorningstarRouteImport } from './routes/pt.o-morningstar'
import { Route as PtObservacaoDeGolfinhosVilamouraRouteImport } from './routes/pt.observacao-de-golfinhos-vilamoura'
import { Route as PtPasseiosDeBarcoAlbufeiraRouteImport } from './routes/pt.passeios-de-barco-albufeira'
import { Route as PtPasseiosDeBarcoFaroRouteImport } from './routes/pt.passeios-de-barco-faro'
import { Route as PtPasseiosDeBarcoQuarteiraRouteImport } from './routes/pt.passeios-de-barco-quarteira'
import { Route as PtPasseiosDeBarcoVilamouraRouteImport } from './routes/pt.passeios-de-barco-vilamoura'
import { Route as PtPoliticaDeCookiesRouteImport } from './routes/pt.politica-de-cookies'
import { Route as PtTermosRouteImport } from './routes/pt.termos'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AlgarveBoatRoute = AlgarveBoatRouteImport.update({
            id: '/algarve-boat',path: '/algarve-boat',getParentRoute: () => rootRouteImport
          })
const AlvorLagoonCruiseRoute = AlvorLagoonCruiseRouteImport.update({
            id: '/alvor-lagoon-cruise',path: '/alvor-lagoon-cruise',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BenagilCaveTourRoute = BenagilCaveTourRouteImport.update({
            id: '/benagil-cave-tour',path: '/benagil-cave-tour',getParentRoute: () => rootRouteImport
          })
const BirthdayCruiseVilamouraRoute = BirthdayCruiseVilamouraRouteImport.update({
            id: '/birthday-cruise-vilamoura',path: '/birthday-cruise-vilamoura',getParentRoute: () => rootRouteImport
          })
const BoatHireAlgarveRoute = BoatHireAlgarveRouteImport.update({
            id: '/boat-hire-algarve',path: '/boat-hire-algarve',getParentRoute: () => rootRouteImport
          })
const BoatHireVilamouraRoute = BoatHireVilamouraRouteImport.update({
            id: '/boat-hire-vilamoura',path: '/boat-hire-vilamoura',getParentRoute: () => rootRouteImport
          })
const BoatTripsAlbufeiraRoute = BoatTripsAlbufeiraRouteImport.update({
            id: '/boat-trips-albufeira',path: '/boat-trips-albufeira',getParentRoute: () => rootRouteImport
          })
const BoatTripsFaroRoute = BoatTripsFaroRouteImport.update({
            id: '/boat-trips-faro',path: '/boat-trips-faro',getParentRoute: () => rootRouteImport
          })
const BoatTripsQuarteiraRoute = BoatTripsQuarteiraRouteImport.update({
            id: '/boat-trips-quarteira',path: '/boat-trips-quarteira',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const DestinationsRoute = DestinationsRouteImport.update({
            id: '/destinations',path: '/destinations',getParentRoute: () => rootRouteImport
          })
const DolphinWatchingVilamouraRoute = DolphinWatchingVilamouraRouteImport.update({
            id: '/dolphin-watching-vilamoura',path: '/dolphin-watching-vilamoura',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const PrivateBoatRentalVilamouraRoute = PrivateBoatRentalVilamouraRouteImport.update({
            id: '/private-boat-rental-vilamoura',path: '/private-boat-rental-vilamoura',getParentRoute: () => rootRouteImport
          })
const PrivateYachtCharterVilamouraRoute = PrivateYachtCharterVilamouraRouteImport.update({
            id: '/private-yacht-charter-vilamoura',path: '/private-yacht-charter-vilamoura',getParentRoute: () => rootRouteImport
          })
const ProposalCruiseVilamouraRoute = ProposalCruiseVilamouraRouteImport.update({
            id: '/proposal-cruise-vilamoura',path: '/proposal-cruise-vilamoura',getParentRoute: () => rootRouteImport
          })
const PtRoute = PtRouteImport.update({
            id: '/pt',path: '/pt',getParentRoute: () => rootRouteImport
          })
const RiaFormosaTaviraCruiseRoute = RiaFormosaTaviraCruiseRouteImport.update({
            id: '/ria-formosa-tavira-cruise',path: '/ria-formosa-tavira-cruise',getParentRoute: () => rootRouteImport
          })
const SunsetCruiseVilamouraRoute = SunsetCruiseVilamouraRouteImport.update({
            id: '/sunset-cruise-vilamoura',path: '/sunset-cruise-vilamoura',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TheMorningstarRoute = TheMorningstarRouteImport.update({
            id: '/the-morningstar',path: '/the-morningstar',getParentRoute: () => rootRouteImport
          })
const TrustCentreRoute = TrustCentreRouteImport.update({
            id: '/trust-centre',path: '/trust-centre',getParentRoute: () => rootRouteImport
          })
const VilamouraBoatTripsRoute = VilamouraBoatTripsRouteImport.update({
            id: '/vilamoura-boat-trips',path: '/vilamoura-boat-trips',getParentRoute: () => rootRouteImport
          })
const VilamouraHenPartyCruiseRoute = VilamouraHenPartyCruiseRouteImport.update({
            id: '/vilamoura-hen-party-cruise',path: '/vilamoura-hen-party-cruise',getParentRoute: () => rootRouteImport
          })
const PtIndexRoute = PtIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PtRoute
          })
const PtAluguerDeBarcoAlgarveRoute = PtAluguerDeBarcoAlgarveRouteImport.update({
            id: '/aluguer-de-barco-algarve',path: '/aluguer-de-barco-algarve',getParentRoute: () => PtRoute
          })
const PtAluguerDeBarcoVilamouraRoute = PtAluguerDeBarcoVilamouraRouteImport.update({
            id: '/aluguer-de-barco-vilamoura',path: '/aluguer-de-barco-vilamoura',getParentRoute: () => PtRoute
          })
const PtBarcoAlgarveRoute = PtBarcoAlgarveRouteImport.update({
            id: '/barco-algarve',path: '/barco-algarve',getParentRoute: () => PtRoute
          })
const PtCentroDeConfiancaRoute = PtCentroDeConfiancaRouteImport.update({
            id: '/centro-de-confianca',path: '/centro-de-confianca',getParentRoute: () => PtRoute
          })
const PtCharterIatePrivadoVilamouraRoute = PtCharterIatePrivadoVilamouraRouteImport.update({
            id: '/charter-iate-privado-vilamoura',path: '/charter-iate-privado-vilamoura',getParentRoute: () => PtRoute
          })
const PtCruzeiroAniversarioVilamouraRoute = PtCruzeiroAniversarioVilamouraRouteImport.update({
            id: '/cruzeiro-aniversario-vilamoura',path: '/cruzeiro-aniversario-vilamoura',getParentRoute: () => PtRoute
          })
const PtCruzeiroDespedidaSolteiraVilamouraRoute = PtCruzeiroDespedidaSolteiraVilamouraRouteImport.update({
            id: '/cruzeiro-despedida-solteira-vilamoura',path: '/cruzeiro-despedida-solteira-vilamoura',getParentRoute: () => PtRoute
          })
const PtCruzeiroLagunaAlvorRoute = PtCruzeiroLagunaAlvorRouteImport.update({
            id: '/cruzeiro-laguna-alvor',path: '/cruzeiro-laguna-alvor',getParentRoute: () => PtRoute
          })
const PtCruzeiroPedidoCasamentoVilamouraRoute = PtCruzeiroPedidoCasamentoVilamouraRouteImport.update({
            id: '/cruzeiro-pedido-casamento-vilamoura',path: '/cruzeiro-pedido-casamento-vilamoura',getParentRoute: () => PtRoute
          })
const PtCruzeiroPorDoSolVilamouraRoute = PtCruzeiroPorDoSolVilamouraRouteImport.update({
            id: '/cruzeiro-por-do-sol-vilamoura',path: '/cruzeiro-por-do-sol-vilamoura',getParentRoute: () => PtRoute
          })
const PtCruzeiroRiaFormosaTaviraRoute = PtCruzeiroRiaFormosaTaviraRouteImport.update({
            id: '/cruzeiro-ria-formosa-tavira',path: '/cruzeiro-ria-formosa-tavira',getParentRoute: () => PtRoute
          })
const PtDestinosRoute = PtDestinosRouteImport.update({
            id: '/destinos',path: '/destinos',getParentRoute: () => PtRoute
          })
const PtFaqRoute = PtFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => PtRoute
          })
const PtGrutaDeBenagilRoute = PtGrutaDeBenagilRouteImport.update({
            id: '/gruta-de-benagil',path: '/gruta-de-benagil',getParentRoute: () => PtRoute
          })
const PtOMorningstarRoute = PtOMorningstarRouteImport.update({
            id: '/o-morningstar',path: '/o-morningstar',getParentRoute: () => PtRoute
          })
const PtObservacaoDeGolfinhosVilamouraRoute = PtObservacaoDeGolfinhosVilamouraRouteImport.update({
            id: '/observacao-de-golfinhos-vilamoura',path: '/observacao-de-golfinhos-vilamoura',getParentRoute: () => PtRoute
          })
const PtPasseiosDeBarcoAlbufeiraRoute = PtPasseiosDeBarcoAlbufeiraRouteImport.update({
            id: '/passeios-de-barco-albufeira',path: '/passeios-de-barco-albufeira',getParentRoute: () => PtRoute
          })
const PtPasseiosDeBarcoFaroRoute = PtPasseiosDeBarcoFaroRouteImport.update({
            id: '/passeios-de-barco-faro',path: '/passeios-de-barco-faro',getParentRoute: () => PtRoute
          })
const PtPasseiosDeBarcoQuarteiraRoute = PtPasseiosDeBarcoQuarteiraRouteImport.update({
            id: '/passeios-de-barco-quarteira',path: '/passeios-de-barco-quarteira',getParentRoute: () => PtRoute
          })
const PtPasseiosDeBarcoVilamouraRoute = PtPasseiosDeBarcoVilamouraRouteImport.update({
            id: '/passeios-de-barco-vilamoura',path: '/passeios-de-barco-vilamoura',getParentRoute: () => PtRoute
          })
const PtPoliticaDeCookiesRoute = PtPoliticaDeCookiesRouteImport.update({
            id: '/politica-de-cookies',path: '/politica-de-cookies',getParentRoute: () => PtRoute
          })
const PtTermosRoute = PtTermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => PtRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const PtRouteChildren = {
  PtAluguerDeBarcoAlgarveRoute: PtAluguerDeBarcoAlgarveRoute,PtAluguerDeBarcoVilamouraRoute: PtAluguerDeBarcoVilamouraRoute,PtBarcoAlgarveRoute: PtBarcoAlgarveRoute,PtCentroDeConfiancaRoute: PtCentroDeConfiancaRoute,PtCharterIatePrivadoVilamouraRoute: PtCharterIatePrivadoVilamouraRoute,PtCruzeiroAniversarioVilamouraRoute: PtCruzeiroAniversarioVilamouraRoute,PtCruzeiroDespedidaSolteiraVilamouraRoute: PtCruzeiroDespedidaSolteiraVilamouraRoute,PtCruzeiroLagunaAlvorRoute: PtCruzeiroLagunaAlvorRoute,PtCruzeiroPedidoCasamentoVilamouraRoute: PtCruzeiroPedidoCasamentoVilamouraRoute,PtCruzeiroPorDoSolVilamouraRoute: PtCruzeiroPorDoSolVilamouraRoute,PtCruzeiroRiaFormosaTaviraRoute: PtCruzeiroRiaFormosaTaviraRoute,PtDestinosRoute: PtDestinosRoute,PtFaqRoute: PtFaqRoute,PtGrutaDeBenagilRoute: PtGrutaDeBenagilRoute,PtOMorningstarRoute: PtOMorningstarRoute,PtObservacaoDeGolfinhosVilamouraRoute: PtObservacaoDeGolfinhosVilamouraRoute,PtPasseiosDeBarcoAlbufeiraRoute: PtPasseiosDeBarcoAlbufeiraRoute,PtPasseiosDeBarcoFaroRoute: PtPasseiosDeBarcoFaroRoute,PtPasseiosDeBarcoQuarteiraRoute: PtPasseiosDeBarcoQuarteiraRoute,PtPasseiosDeBarcoVilamouraRoute: PtPasseiosDeBarcoVilamouraRoute,PtPoliticaDeCookiesRoute: PtPoliticaDeCookiesRoute,PtTermosRoute: PtTermosRoute,PtIndexRoute: PtIndexRoute
}

const PtRouteWithChildren = PtRoute._addFileChildren(PtRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AlgarveBoatRoute: AlgarveBoatRoute,AlvorLagoonCruiseRoute: AlvorLagoonCruiseRoute,AuthRoute: AuthRoute,BenagilCaveTourRoute: BenagilCaveTourRoute,BirthdayCruiseVilamouraRoute: BirthdayCruiseVilamouraRoute,BoatHireAlgarveRoute: BoatHireAlgarveRoute,BoatHireVilamouraRoute: BoatHireVilamouraRoute,BoatTripsAlbufeiraRoute: BoatTripsAlbufeiraRoute,BoatTripsFaroRoute: BoatTripsFaroRoute,BoatTripsQuarteiraRoute: BoatTripsQuarteiraRoute,CookiePolicyRoute: CookiePolicyRoute,DestinationsRoute: DestinationsRoute,DolphinWatchingVilamouraRoute: DolphinWatchingVilamouraRoute,FaqRoute: FaqRoute,PrivateBoatRentalVilamouraRoute: PrivateBoatRentalVilamouraRoute,PrivateYachtCharterVilamouraRoute: PrivateYachtCharterVilamouraRoute,ProposalCruiseVilamouraRoute: ProposalCruiseVilamouraRoute,PtRoute: PtRouteWithChildren,RiaFormosaTaviraCruiseRoute: RiaFormosaTaviraCruiseRoute,SunsetCruiseVilamouraRoute: SunsetCruiseVilamouraRoute,TermsRoute: TermsRoute,TheMorningstarRoute: TheMorningstarRoute,TrustCentreRoute: TrustCentreRoute,VilamouraBoatTripsRoute: VilamouraBoatTripsRoute,VilamouraHenPartyCruiseRoute: VilamouraHenPartyCruiseRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)